<template>
  <div>
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div v-show="!showDetailPanel" class="key-road">
      <exportDate v-if="showExport" @hideExport="showExport = false" :tab="tab" :moduleName="moduleName"
                  :moduleType="pRoadType"/>
      <div class="header">
        <TitleHeader @on-change-tab="onChangeTab" :tab="tab"/>
        <div class="righth" v-if="pRoadType == 'PROVINCIAL_HIGHWAY'">
          <span style="margin-right:30px;">
            <span class="demonstration">省份</span>
            <el-select v-model="provinceName" placeholder="请选择活动区域" @change="onChangeParams">
              <el-option v-if="areaList.length>1" label="全部" value></el-option>
              <el-option v-for="(item,index) in areaList" :label="item.provinceName" :value="item.provinceName"
                         :key="index"></el-option>
            </el-select>
          </span>
          <span>
            <span class="demonstration">统计月份</span>
            <el-date-picker style="width: 180px;" v-model="monTime" type="month" :clearable="false" placeholder="选择月"
                            @change="onChangeParams" value-format="yyyy-MM"></el-date-picker>
          </span>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
          <el-button v-show="hideExport" style="margin-left:15px;" @click="showWeekDialog = true">导出全部明细</el-button>
        </div>
      </div>
      <WeekStatisticsTip style="margin-bottom: 20px; margin-top:20px;" v-if="pRoadType != 'PROVINCIAL_HIGHWAY'" />
      <el-form :inline="true" v-if="pRoadType != 'PROVINCIAL_HIGHWAY'&&tab==2">
        <!--        <el-form-item label="统计月份" label-width="75px">-->
        <!--          <el-date-picker style="width: 120px;" v-model="monTime" type="month" :clearable="false" placeholder="选择月"-->
        <!--                          @change="onChangeParams" value-format="yyyy-MM"></el-date-picker>-->
        <!--        </el-form-item>-->
        <el-form-item label="统计周" label-width="75px">
          <WeekPopover @on-command="onWeekPopOverCommand" :roadType="pRoadType == 'HIGHWAY'?1:2" :tabNum="tab"
                       ref="weekPopoverRef"/>
        </el-form-item>
        <el-form-item label="道路分类" label-width="75px">
          <el-select v-model="formData.daoluType" placeholder="请选择">
            <el-option
                v-for="item in daoluOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
              v-if="areaListPr.length>0"
              :options="areaListPr"
              v-model="formData.provCityCounty"
              :props="propsData()"
              filterable
              :before-filter="filterMethod"
              clearable></el-cascader>
        </el-form-item>
        <template v-if="value1">
          <el-form-item label="道路编码" label-width="75px">
            <el-input v-model="formData.companyName" clearable placeholder="请输入道路编码"></el-input>
          </el-form-item>
          <el-form-item label="站点名称" label-width="75px">
            <el-input v-model="formData.stationName" clearable placeholder="请输入站点名称"></el-input>
          </el-form-item>
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料类型" label-width="75px">
            <el-select v-model="formData.ranliaoType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in ranliaoOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点类型" label-width="75px">
            <el-select v-model="formData.zhanDianType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点品牌" label-width="75px">
            <el-select v-model="formData.zhanDianBrand" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianBrandOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-button style="margin-left:10px;" class="searchBtn" @click="initData(1,true)">查询</el-button>
        <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
        <el-button v-show="hideExport" style="margin-left:10px;" @click="showWeekDialog = true">导出全部明细</el-button>
        <el-switch
            v-model="value1"
            style="margin-left: 10px"
            active-text="展开"
            inactive-text="收起">
        </el-switch>
      </el-form>
      <el-form :inline="true" v-if="pRoadType != 'PROVINCIAL_HIGHWAY'&&tab!=2">
        <el-form-item label="统计周" label-width="75px">
          <WeekPopover @on-command="onWeekPopOverCommand" :roadType="pRoadType == 'HIGHWAY'?1:2" :tabNum="tab"
                       ref="weekPopoverRef"/>
        </el-form-item>
        <el-form-item label="道路分类" label-width="75px">
          <el-select v-model="formData.daoluType" placeholder="请选择">
            <el-option
                v-for="item in daoluOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
              v-if="areaListPr.length>0"
              :options="areaListPr"
              v-model="formData.provCityCounty"
              :props="propsData()"
              filterable
              :before-filter="filterMethod"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="吨位区间" label-width="75px">
          <el-select v-model="formData.dunwei" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in dunWeiOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="燃料类型" label-width="75px">
          <el-select v-model="formData.ranliaoType" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in ranliaoOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="站点类型" v-if="tab === 1" label-width="75px">
          <el-select v-model="formData.zhanDianType" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in zhanDianOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="道路编码" label-width="75px">
          <el-input v-model="formData.companyName" clearable placeholder="请输入道路编码"></el-input>
        </el-form-item>
        <el-button style="margin-left:10px;" class="searchBtn" @click="initData(1,true)">查询</el-button>
        <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
        <el-button v-show="hideExport" style="margin-left:10px;" @click="showWeekDialog = true">导出全部明细</el-button>
      </el-form>
      <WeekDialog @on-command="onWeekDialogCommand" :roadType="pRoadType == 'HIGHWAY'?1:2" :tabNum="tab"
                  v-if="showWeekDialog"/>
      <main v-if="pRoadType == 'PROVINCIAL_HIGHWAY'">
        <StopTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 0" :index="indexAll"></StopTable>
        <TimeTable @on-to-detail="onToDetail" :allData="allData" v-else :index="indexAll"></TimeTable>
      </main>
      <main v-if="pRoadType != 'PROVINCIAL_HIGHWAY'">
        <operateTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 0" :index="indexAll"></operateTable>
        <flowRateTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 1" :index="indexAll"></flowRateTable>
        <stopNewTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 2" :index="indexAll"></stopNewTable>
      </main>
      <div class="block" style>
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
    <DescFooter v-show="!showDetailPanel"/>
    <Detail v-if="showDetailPanel" @on-change-tab="onChangeTab" @on-close="showDetailPanel = false" :pTab="detailTab"
            :pDefaultTime="detailDefaultTime" :pRoadCode="detailRoadCode"/>
  </div>
</template>
<script>
import TitleHeader from './titleHeader.vue' // 头部切换
import StopTable from './stopTable.vue' // 加油站停靠表格
import TimeTable from './timeTable.vue' // 运营时段表格
import flowRateTable from './flowRateTable.vue' // 流量
import operateTable from './operateTable.vue' // 运营
import stopNewTable from './stopNewTable.vue' // 停靠
import DescFooter from './descFooter.vue' // 底部说明
import Detail from '../detail/index.vue'
import nameMixin from './nameMixin'

import http from '@/api/freight.js' //请求汇总
import {hideExport, mergeTree} from '@/utils/tools'
import Util from "utils/util";
import WeekPopover from "./weekPopover.vue";
import WeekDialog from "./weekDialog.vue";
import Cookies from "js-cookie";
import {
  collectAnalysisCustomerEx2,
  nationaloperateStatisticsWExportScreen,
  nationaloperateStopDetailExportScreen,
  operateStatisticsExportScreen,
  operateStatisticsWExportScreen,
  operateStopDetailExportScreen,
  operateStopDetailExportScreenW,
  progress
} from "api/log";
import WeekStatisticsTip from "@/components/WeekStatisticsTip.vue";

export default {
  mixins: [nameMixin],
  name: 'key-road',
  components: {
    WeekDialog,
    WeekPopover,
    StopTable,
    flowRateTable,
    operateTable,
    stopNewTable,
    TimeTable,
    TitleHeader,
    DescFooter,
    Detail,
    WeekStatisticsTip,
  },
  data() {
    var now = new Date()
    now.setMonth(now.getMonth() - 1)

    return {
      ranliaoOption: Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      daoluOption: Util.daoLuFenLei,
      zhanDianOption: Util.zhanDianOption,
      zhanDianBrandOption: Util.zhanDianBrandOptionT,
      value1: true,
      showWeekDialog: false,
      formData: {
        provCityCounty: '',
        ranliaoType: [],
        zhanDianType: [],
        zhanDianBrand: [],
        companyName: '',
        dunwei: [],
        daoluType: '',
        sourceGastype: 1,
        stationName:''
      },
      areaListPr: [],
      hideExport: hideExport,
      showExport: false, //控制批量导出
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      areaList: [],
      provinceName: '',
      monTime: now,
      total: 0, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth: '', //请求日期
      pageSize: 20,
      indexAll: 0,

      showDetailPanel: false, // 显示详情面板
      detailTab: 0,
      detailDefaultTime: '',
      detailRoadCode: '',
      mark: false, //遮罩层开关
      progressNum: 0, //下载进度条进度
    }
  },
  created() {
    let type = this.$route.query.type
    this.tab = type ? type : 0
  },
  mounted() {
    let time = this.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    this.endMonth = year + this.initMonth(month)
    if (this.pRoadType == 'NATIONAL_HIGHWAY'){
      this.daoluOption = Util.daoLuFenLeiGd
    }else{
      this.daoluOption = Util.daoLuFenLei
    }
    // this.initData()
    // this.getProvinces()
    this.getPrInter()
  },
  methods: {
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({ keyword: value })
          .then(({ data }) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      if (this.pRoadType != 'PROVINCIAL_HIGHWAY') {
        console.log(this.endMonth)
        if (this.tab != 2) {
          if (this.pRoadType == 'HIGHWAY') {
            window.location.assign(
                operateStatisticsWExportScreen({
                  reqId,
                  provincecode: this.formData.provCityCounty[0] || '',
                  citycode: this.formData.provCityCounty[1] || '',
                  countycode: this.formData.provCityCounty[2] || '',

                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  sourceGastype: this.formData.sourceGastype,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2,
                  ...curSelectedWeek
                })
            )
          }
          if (this.pRoadType == 'NATIONAL_HIGHWAY') {
            // 国道
            window.location.assign(
                nationaloperateStatisticsWExportScreen({
                  reqId,
                  ...curSelectedWeek,
                  provincecode: this.formData.provCityCounty[0] || '',
                  citycode: this.formData.provCityCounty[1] || '',
                  countycode: this.formData.provCityCounty[2] || '',

                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  sourceGastype: this.formData.sourceGastype,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2,
                })
            )
          }
        } else {
          window.location.assign(
              operateStopDetailExportScreenW({
                reqId,
                // year: this.endMonth.substring(0, 4),
                // month: this.endMonth.substring(4, 6),
                ...curSelectedWeek,
                provincecode: this.formData.provCityCounty[0] || '',
                citycode: this.formData.provCityCounty[1] || '',
                countycode: this.formData.provCityCounty[2] || '',

                roadcode: this.formData.companyName,
                tonnages: this.formData.dunwei,
                roadClass: this.formData.daoluType,
                sourceGastype: this.formData.sourceGastype,
                fuelTypes: this.formData.ranliaoType,
                stationTypes: this.formData.zhanDianType,
                kinds: this.formData.zhanDianBrand,

                stationName:this.formData.stationName,

                roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2
              })
          )
        }
      }
    },
    onWeekDialogCommand(params) {
      console.log('123123')
      switch (params.type) {
        case 'ok':
          console.log(params)
          if (this.tab == 0) {
            window.location.assign(http.operateStatisticsExportW({
              ...params.data,
              ...this.formData,
              roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2
            }))
          }
          if (this.tab == 1) {
            window.location.assign(http.addEnergyExportW({
              ...params.data,
              ...this.formData,
              roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2
            }))
          }
          if (this.tab == 2) {
            window.location.assign(http.addEnergyStopInfoExportW({
              ...params.data,
              ...this.formData,
              roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2
            }))
          }

          // if (this.pRoadType != 'PROVINCIAL_HIGHWAY') {
          //   if (this.tab!=2){
          //     if (this.pRoadType == 'HIGHWAY'){
          //
          //     }
          //     if (this.pRoadType == 'NATIONAL_HIGHWAY'){
          //
          //     }
          //   }
          // }
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.initData()
          break
        default:
          break
      }
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
      if (this.areaListPr.length == 1) {
        this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const { data } = await http.getCountyAreaList({
          code,
          type: '1',
          areaType: 'CITY'
        })
        // 获取已存在的 value 列表
        const existValues = new Set()
        if (this.areaListPr && Array.isArray(this.areaListPr)) {
          this.areaListPr.forEach(item => {
            if (item.children && Array.isArray(item.children)) {
              item.children.forEach(child => existValues.add(child.value))
            }
          })
        }
        // 过滤已存在的
        const nodes = data
            .filter(item => !existValues.has(item.code))
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf:
                  code == '110000' ||
                  code == '120000' ||
                  code == '500000' ||
                  code == '310000' ||
                  code == '900000'
                      ? true
                      : false
            }))
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes)
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const { data } = await http.getCountyAreaList({
          code,
          type: '1',
          areaType: 'COUNTY'
        })
        // 获取已存在的 value 列表
        const existValues = new Set()
        if (this.areaListPr && Array.isArray(this.areaListPr)) {
          this.areaListPr.forEach(item => {
            if (item.children && Array.isArray(item.children)) {
              item.children.forEach(child => {
                if (child.children && Array.isArray(child.children)) {
                  child.children.forEach(grand => existValues.add(grand.value))
                }
              })
            }
          })
        }
        // 过滤已存在的
        const nodes = data
            .filter(item => !existValues.has(item.code))
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }))
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes)
      })
    },
    getProvinces() {
      http.getProvinces().then((e) => {
        this.areaList = e.data
      })
    },

    initData(num = 0, flag) {
      if (flag) {
        this.index = 1
        this.indexAll = 0
      }
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.pRoadType != 'PROVINCIAL_HIGHWAY') {
        if (this.tab != 2) {
          if (this.pRoadType == 'HIGHWAY') {
            http
                .operateStatisticsW({
                  pageNum: this.index,
                  pageSize: this.pageSize,
                  // year: this.endMonth.substring(0, 4),
                  // month: this.endMonth.substring(4, 6),
                  provincecode: this.formData.provCityCounty[0] || '',
                  citycode: this.formData.provCityCounty[1] || '',
                  countycode: this.formData.provCityCounty[2] || '',

                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  sourceGastype: this.formData.sourceGastype,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2,
                  // countTime: this.endMonth,
                  // firstIs: num,
                  // provinceName: this.provinceName,
                  // moduleType: this.pRoadType,
                  ...curSelectedWeek
                })
                .then((e) => {
                  loading.close();
                  if (e.data && e.data.dataList && e.data.dataList) {
                    this.allData = [...e.data.dataList]
                    this.total = e.data.total
                    // this.monTime = e.data.time
                    // let time = e.data.time
                    // this.endMonth = time.replace('-', '')
                  } else {
                    this.allData = []
                    this.total = 0
                  }
                })
          }
          if (this.pRoadType == 'NATIONAL_HIGHWAY') {
            http
                .nationalOW({
                  pageNum: this.index,
                  pageSize: this.pageSize,
                  // year: this.endMonth.substring(0, 4),
                  // month: this.endMonth.substring(4, 6),
                  ...curSelectedWeek,
                  provincecode: this.formData.provCityCounty[0] || '',
                  citycode: this.formData.provCityCounty[1] || '',
                  countycode: this.formData.provCityCounty[2] || '',

                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  sourceGastype: this.formData.sourceGastype,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2,
                  // countTime: this.endMonth,
                  // firstIs: num,
                  // provinceName: this.provinceName,
                  // moduleType: this.pRoadType,
                })
                .then((e) => {
                  loading.close();
                  if (e.data && e.data.dataList && e.data.dataList) {
                    this.allData = [...e.data.dataList]
                    this.total = e.data.total
                    // this.monTime = e.data.time
                    // let time = e.data.time
                    // this.endMonth = time.replace('-', '')
                  } else {
                    this.allData = []
                    this.total = 0
                  }
                })
          }
        } else {
          http
              .operateStopDetailW({
                pageNum: this.index,
                pageSize: this.pageSize,
                // year: this.endMonth.substring(0, 4),
                // month: this.endMonth.substring(4, 6),
                ...curSelectedWeek,
                provincecode: this.formData.provCityCounty[0] || '',
                citycode: this.formData.provCityCounty[1] || '',
                countycode: this.formData.provCityCounty[2] || '',

                roadcode: this.formData.companyName,
                tonnages: this.formData.dunwei,
                roadClass: this.formData.daoluType,
                sourceGastype: this.formData.sourceGastype,
                fuelTypes: this.formData.ranliaoType,
                stationTypes: this.formData.zhanDianType,
                kinds: this.formData.zhanDianBrand,

                stationName:this.formData.stationName,

                roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2

                // countTime: this.endMonth,
                // firstIs: num,
                // provinceName: this.provinceName,
                // moduleType: this.pRoadType,
              })
              .then((e) => {
                loading.close();
                if (e.data && e.data.dataList && e.data.dataList) {
                  this.allData = e.data.dataList.map(item => {
                    item.stationTypeName = this.zhanDianOption.filter(item2 => item.stationType == item2.value)[0].label
                    return item
                  })
                  this.total = e.data.total
                  // this.monTime = e.data.time
                  // let time = e.data.time
                  // this.endMonth = time.replace('-', '')
                } else {
                  this.allData = []
                  this.total = 0
                }
              })
        }

      } else {
        http
            .carOperate({
              page: this.index,
              pageSize: this.pageSize,
              countTime: this.endMonth,
              firstIs: num,
              provinceName: this.provinceName,
              moduleType: this.pRoadType,
            })
            .then((e) => {
              loading.close();
              if (e.data && e.data.tPageUtil && e.data.tPageUtil.list) {
                this.allData = [...e.data.tPageUtil.list]
                this.total = e.data.tPageUtil.count
                this.monTime = e.data.time
                let time = e.data.time
                this.endMonth = time.replace('-', '')
              } else {
                this.allData = []
                this.total = 0
              }
            })
      }
    },

    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },

    onToDetail(roadCode) {
      this.showDetailPanel = true
      this.detailTab = this.tab
      this.detailDefaultTime = this.endMonth
      this.detailRoadCode = roadCode
    },

    onChangeTab(tabIndex) {
      this.tab = tabIndex
      this.allData = []
      var now = new Date()
      now.setMonth(now.getMonth() - 1)
      let time = now
      let year = time.getFullYear()
      let month = time.getMonth()
      this.monTime = now
      this.endMonth = year + this.initMonth(month)
      this.indexAll = 0
      this.index = 1
      this.formData = {
        provCityCounty: '',
        ranliaoType: [],
        zhanDianType: [],
        zhanDianBrand: [],
        companyName: '',
        dunwei: [],
        daoluType: '',
        sourceGastype: 1
      }
      // this.initData()
    },

    onChangeParams() {
      let time = this.monTime
      let arr = time.split('-')
      this.index = 1
      this.indexAll = 0
      this.endMonth = arr[0] + '' + arr[1]
    },

    onChangePage(index) {
      this.index = index
      this.initData(1)
      this.indexAll = this.pageSize * (index - 1)
    },
  },
}
</script>

<style lang='stylus' scoped>
.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: #336db0;

  &::after {
    background: #336db0;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.key-road {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.block {
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>
